/* eslint-disable import/prefer-default-export */
import { useMemo, useCallback } from 'react';
import { getMaskedPhone } from '../services/phone/getMaskedPhone';

export const usePhoneDisplay = ({ phone, user }) => {
  const getPhone = useCallback(
    (masked = true) => getMaskedPhone({ phone, user, masked }),
    [phone, user]
  );

  const maskedPhone = useMemo(
    () => getPhone(true),
    [getPhone]
  );

  return {
    maskedPhone,
    getPhone
  };
};
